/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleData {
    getFixupPrototypeFunction() { return ScheduleData.fixupPrototype; }

    static newInstance(model: Partial<ScheduleData>): ScheduleData {
        let obj = Object.assign(new ScheduleData(), model);
        ScheduleData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleData>): ScheduleData {
        if (!model) return null;
        return ScheduleData.newInstance(<ScheduleData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleData) {
        if (!obj) return;

        models.ScheduleData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleData): boolean {
        Object.setPrototypeOf(obj, ScheduleData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource_details) {
            for (let val of this.resource_details) {
                models.ResourceDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Schedule ID
     */
    id: string;

    /**
     * Schedule Name
     */
    name: string;

    /**
     * Schedule type
     */
    type: models.ScheduleType;

    /**
     * Description of the schedule
     */
    description: string;

    /**
     * Re-occurrence of the schedule
     */
    recurrence: string;

    /**
     * When will the schedule run for the next time
     */
    next_run: string;

    /**
     * Schedule date and time details
     */
    schedule: any;

    /**
     * Input Parameters for that Template/Policy that is scheduled
     */
    args: any;

    /**
     * Template/Policy Details that is scheduled
     */
    resource_details: Array<models.ResourceDetails>;

    /**
     * When the schedule is created
     */
    created_at: string;

    /**
     * Who has created the schedule
     */
    created_by: string;

}
